import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { transactionsService, ExportTransactionsRequest } from '@aslanpay/portal-common-lib';

const useExportTransactions = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, ExportTransactionsRequest>) => {
  return useMutation<unknown, Error, ExportTransactionsRequest>(
    ({
      ids,
      individualIds,
      walletIds,
      companyIds,
      directions,
      categories = [
        'PURCHASE',
        'POINTS_REDEMPTION',
        'DEPOSIT',
        'WITHDRAW',
        'REFUND',
        'CHARGEBACK',
        'CHARGEBACK_CREDIT',
        'CHARGEBACK_DEBIT',
      ],
      status,
      query,
      startDate,
      endDate,
      settledAtStartDate,
      settledAtEndDate,
      minAmount,
      maxAmount,
      countryCodes,
      riskRuleCodes,
      isSuspicious,
      withNotes = false,
      withSuspiciousInfo = false,
    }: ExportTransactionsRequest) =>
      transactionsService.exportTransactions({
        ids,
        individualIds,
        walletIds,
        companyIds,
        directions,
        categories,
        status,
        query,
        startDate,
        endDate,
        settledAtStartDate,
        settledAtEndDate,
        minAmount,
        maxAmount,
        countryCodes,
        riskRuleCodes,
        isSuspicious,
        withNotes,
        withSuspiciousInfo,
      }),
    { onSuccess, onError }
  );
};

export default useExportTransactions;
